import Grid from '@mui/material/Grid';
import { Stack } from '@mui/material';

import { useDrawerFilter } from '@hapvida/hapvida-core-components';

import { SubHeader } from '@components';
import { useFilterParams } from '@hooks';
import { NewFilterDrawerUsersBackoffice } from 'components/filters/NewFiltersParams/NewFilterDrawerUsersBackoffice';
import NewSearchField from 'components/filters/NewFiltersParams/NewSearchField';

import { useBackofficeUserMobileState } from '../../hooks/useBackofficeUserState';

export function UserBackofficeListSubHeaderMobile() {
  const { hasFilters } = useFilterParams();
  const { filterCount } = useDrawerFilter();
  const { backofficeUserMobileState } = useBackofficeUserMobileState();

  const { data: dataMobile } = backofficeUserMobileState;

  const { isError, isLoading } = backofficeUserMobileState;

  const totalUsersListLength = dataMobile?.pages[0].total ?? 0;

  const isResultEmpty = totalUsersListLength === 0;

  const searchButtonDisabled = isLoading && hasFilters;

  const filtersDrawerButtonDisabled =
    !filterCount && (isLoading || isResultEmpty);

  const isLoadingWithoutFilters = isLoading && !hasFilters;

  const isEmptyWithoutFilters = isResultEmpty && !hasFilters;

  const isErrorWithoutFilters = isError && !hasFilters;

  if (
    isLoadingWithoutFilters ||
    isErrorWithoutFilters ||
    isEmptyWithoutFilters
  ) {
    return null;
  }

  return (
    <SubHeader>
      <Grid container spacing={3}>
        <Grid item width={'100%'} display={'flex'} gap={'16px'}>
          <Stack flexGrow={1}>
            <NewSearchField
              name="search"
              currentResultLength={totalUsersListLength}
              placeholder="Buscar nome do usuário, e-mail ou CPF"
              disableSearch={searchButtonDisabled}
            />
          </Stack>
          <NewFilterDrawerUsersBackoffice
            subtitle="Selecione como deseja filtrar os usuários"
            title="Filtrar usuários"
            disabled={filtersDrawerButtonDisabled}
          />
        </Grid>
      </Grid>
    </SubHeader>
  );
}
